module.exports = __webpack_public_path__ + "static/media/icon-volume_off.e4a8c82e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-volume_off.svg
// module id = ./src/assets/images/icon-volume_off.svg
// module chunks = 0